// 生产环境配置
import { isJwInlandApp, isJwIntlApp } from "../utils/app/env";

const deployDir = "/";
const hostname = "https://school.basejy.com";
const appUrl = `${hostname}`;
const JW_APP_URL = `${hostname}`;
const activityMarketOrigin =
  typeof window !== "undefined" && window.location?.origin ? window.location.origin : hostname;

export default {
  SERVER_URL: "https://schoolapi.basejy.com", // 后端服务域名
  BASE_SALES_SERVER_URL: "https://api.basejy.com", // base-sales 网关（勿走智校 SERVER_URL）
  BASE_USER_BEHAVIOR_SERVER_URL: "https://schoolapi.basejy.com",
  DEPLOY_DIR: deployDir, // 项目部署的目录
  APP_URL: appUrl, // 本项目访问地址
  ACTIVITY_MARKET_ORIGIN: activityMarketOrigin,
  H5_STATIC_SERVER_URL: "https://school.basejy.com", // h5页面访问地址
  WX_APPID: "wxae050b3b7db880a5", // 微信公众号appid
  WX_MP_APP_ID: "wxae050b3b7db880a5", // 微信公众号扫码登录使用
  SHOW_MAI_DIAN_LOG: true, // 是否打印埋点日志到浏览器控制台
  ALLOW_MOBILE_LOGIN_PAGE: true, // 是否打开手机登录页面
  JW_APP_URL: JW_APP_URL,
  JW_KUAIPK_APP_URL: "https://kuaipk.basejy.com/",
  JW_KUAIJW_APP_URL: "https://jw.basejy.com/",
  JW_KUAIJK_APP_URL: "https://kuaijk.basejy.com/",
  JW_KUAIXK_APP_URL: `${JW_APP_URL}-kuaixk`,
  JW_KUAIFB_APP_URL: `${JW_APP_URL}-kuaifb`,
  JW_KUAICJ_APP_URL: "https://kuaicj.basejy.com/",
  AI_CHATBOT_BASE_URL: "https://api.basejy.com/base-chatbot", // AI聊天服务地址（生产环境）
  AI_CUSTOMER_BASE_URL: "https://aicustomer.basejy.com", // AI客服服务地址
  KUAI_JW_CONSULTATION_URL: "https://bsjw.basejy.com/#/basejw/kuaijw-consultation",
};

// 生产环境原始配置，临时保留
// const deployDir = isJwInlandApp ? "/kuaipk/" : isJwIntlApp ? "/kuaipk/" : "/";
// const appUrl = isJwInlandApp
//   ? "https://school.basejy.com/kuaipk"
//   : isJwIntlApp
//   ? "https://school.basejy.com/kuaipk"
//   : "https://school.basejy.com";
// const JW_APP_URL = isJwInlandApp
//   ? "https://school.basejy.com"
//   : isJwIntlApp
//   ? "https://school.basejy.com"
//   : "https://school.basejy.com";

// export default {
//   SERVER_URL: "https://schoolapi.basejy.com", // 后端服务域名
//   BASE_USER_BEHAVIOR_SERVER_URL: "https://api.basejy.com",
//   DEPLOY_DIR: deployDir, // 项目部署的目录
//   APP_URL: appUrl, // 本项目访问地址
//   H5_STATIC_SERVER_URL: "https://h5.basejy.com", // h5页面访问地址
//   WX_APPID: "wxae050b3b7db880a5", // 微信公众号appid
//   WX_MP_APP_ID: "wxef1aa2457078e512", // 微信小程序appid
//   SHOW_MAI_DIAN_LOG: false, // 是否打印埋点日志到浏览器控制台
//   ALLOW_MOBILE_LOGIN_PAGE: false, //false, // 是否打开手机登录页面
//   JW_APP_URL: JW_APP_URL,
//   JW_KUAIPK_APP_URL: `${JW_APP_URL}/kuaipk`,
//   JW_KUAIJK_APP_URL: `${JW_APP_URL}/kuaijk`,
//   JW_KUAIXK_APP_URL: `${JW_APP_URL}/kuaixk`,
//   JW_KUAIFB_APP_URL: `${JW_APP_URL}/kuaifb`,
//   JW_KUAICJ_APP_URL: `${JW_APP_URL}/kuaicj`,
// };
